// extracted by mini-css-extract-plugin
module.exports = {"quote":"HighlightedQuote_quote__1MAOt"};